var _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _rect4, _path5, _path6, _rect5, _path7, _rect6, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard5Mob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 200,
    viewBox: "0 0 236 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 49.5556C24.0008 47.5773 25.6045 45.9736 27.5827 45.9736H131.065C133.043 45.9736 134.647 47.5773 134.647 49.5556V55.4823H24.0008V49.5556Z",
    fill: "#B9C7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.646 70.9176C134.646 72.8958 133.042 74.4995 131.064 74.4995L27.5818 74.4995C25.6036 74.4995 23.9999 72.8958 23.9999 70.9175L23.9999 55.4822L134.646 55.4822L134.646 70.9176Z",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 173.931,
    y: 114.438,
    width: 30.1888,
    height: 28.8762,
    rx: 5.41289,
    transform: "rotate(-180 173.931 114.438)",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3253,
    y: 61.533,
    width: 37.1702,
    height: 6.05097,
    rx: 3.02548,
    fill: "#A3BBD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 89.3188C24.0008 87.3405 25.6045 85.7368 27.5827 85.7368H131.065C133.043 85.7368 134.647 87.3405 134.647 89.3188V95.2455H24.0008V89.3188Z",
    fill: "#B9C7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.646 110.681C134.646 112.659 133.042 114.263 131.064 114.263L27.5818 114.263C25.6036 114.263 23.9999 112.659 23.9999 110.681L23.9999 95.2459L134.646 95.2459L134.646 110.681Z",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3253,
    y: 101.296,
    width: 27.6616,
    height: 6.05097,
    rx: 3.02548,
    fill: "#A3BBD1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0391,
    y: 101.296,
    width: 27.6616,
    height: 6.05097,
    rx: 3.02548,
    fill: "#A3BBD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 129.082C24.0008 127.104 25.6045 125.5 27.5827 125.5H131.065C133.043 125.5 134.647 127.104 134.647 129.082V135.009H24.0008V129.082Z",
    fill: "#B9C7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.646 150.444C134.646 152.423 133.042 154.026 131.064 154.026L27.5818 154.026C25.6036 154.026 23.9999 152.423 23.9999 150.444L23.9999 135.009L134.646 135.009L134.646 150.444Z",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3253,
    y: 141.061,
    width: 99.4087,
    height: 6.05097,
    rx: 3.02548,
    fill: "#A3BBD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.198 103.193L154.541 100.536C154.242 100.238 153.76 100.238 153.461 100.536C153.163 100.835 153.163 101.317 153.461 101.616L156.662 104.816C156.96 105.115 157.443 105.115 157.741 104.816L165.842 96.7156C166.141 96.417 166.141 95.9347 165.842 95.6361C165.543 95.3375 165.061 95.3375 164.762 95.6361L157.198 103.193Z",
    fill: "#003A70"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 114.438,
    width: 30.1888,
    height: 28.8762,
    rx: 5.41289,
    transform: "rotate(-180 212 114.438)",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.668 104.181V106.508C190.668 106.723 190.837 106.891 191.051 106.891H193.379C193.478 106.891 193.578 106.853 193.646 106.776L202.007 98.423L199.136 95.5518L190.783 103.905C190.706 103.982 190.668 104.074 190.668 104.181ZM204.228 96.2026C204.526 95.904 204.526 95.4216 204.228 95.123L202.436 93.3314C202.138 93.0328 201.655 93.0328 201.357 93.3314L199.956 94.7325L202.827 97.6037L204.228 96.2026V96.2026Z",
    fill: "#003A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5Mob);
export default __webpack_public_path__ + "static/media/card5_mob.eb154b909db670acdd28941be7d8be6b.svg";
export { ForwardRef as ReactComponent };